import type { MiniAction } from '@otto-ec/tracking-bct';
import type { TrackingGateway } from '@shared/tracking/Tracking.browser';
import type { BlackFridaySliderItem, ProductItem } from '@tilelist/domain/composition/TileListitem.ts';
import {
    BLACK_FRIDAY_SLIDER_FEATURE_ID,
    blackFridaySliderFeatures,
    blackFridaySliderLoadedLabels,
    sliderTileFeatureId,
} from '@tilelist/domain/tracking/SliderTracking.ts';

/*                                                                                                       */
export class BlackFridaySliderTracking {
    private readonly reportedTiles = new Set<number>();

    constructor(private readonly gateway: TrackingGateway) {}

    /*                                */
    reset(): void {
        this.reportedTiles.clear();
    }

    loaded(slider: BlackFridaySliderItem): void {
        if (slider.state === 'pending') return;

        this.reset();
        this.gateway.addToPageImpression(blackFridaySliderLoadedLabels(slider), blackFridaySliderFeatures(slider));
    }

    /*                                                    */
    visible(tiles: ProductItem[]): void {
        this.gateway.submitMiniActions([
            { featureId: BLACK_FRIDAY_SLIDER_FEATURE_ID, action: 'scroll', status: 'visible' },
            ...this.unreportedTileActions(tiles),
        ]);
    }

    /*                                                              */
    browsed(tiles: ProductItem[]): void {
        const actions = this.unreportedTileActions(tiles);
        if (actions.length) this.gateway.submitMiniActions(actions);
    }

    clicked(): void {
        this.gateway.submitMiniActions([
            { featureId: BLACK_FRIDAY_SLIDER_FEATURE_ID, action: 'click', status: 'clicked' },
        ]);
    }

    private unreportedTileActions(tiles: ProductItem[]): MiniAction[] {
        return tiles
            .filter(({ localListPosition }) => !this.reportedTiles.has(localListPosition))
            .map(({ localListPosition }) => {
                this.reportedTiles.add(localListPosition);
                return { featureId: sliderTileFeatureId(localListPosition), action: 'scroll', status: 'visible' };
            });
    }
}
